import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';
import { authTokenService } from '@/services/authTokenService.js';

function __loadGeoJson (studyCode, region, fnCallback) {
	return axios.get(utilityService.getApiUrl('ui/assign/regionId?studyCode=' + studyCode + '&regionId=' + region + '&format=GEO_JSON'),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getRegionList (studyCode, fnCallback) {
	return axios.get(utilityService.getApiUrl('ui/assign/regions?studyCode=' + studyCode),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __loadTablesJson (studyCode, region, fnCallback) {
	return axios.get(utilityService.getApiUrl('ui/assign/regionId?studyCode=' + studyCode + '&regionId=' + region + '&format=JSON'),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __loadGeoJsonDummy (studyCode, region, fnCallback) {
	var data = [];
	return data;
}

function __updateAnaylsis (EagleAssignmentUpdateArray) {
	return axios.post(utilityService.getApiUrl(`analysis/assign/update?studyCode=PATH`),
		EagleAssignmentUpdateArray,
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

// commented out for refactor for update map put endpoint
// function __updateCase (studyCode, oldStaffId, caseAssignment) {
// 	return axios.post(utilityService.getApiUrl(`analysis/assign/update?studyCode=` + studyCode + '&oldStaffId=' + oldStaffId),
// 		caseAssignment,
// 		// "Good morrow to you, sir.",
// 		// Third parameter is the configuration object
// 		{
// 			headers: utilityService.getHeaders()
// 		}
// 	);
// }

// set persist to true to send to elastic search, false to just return data
function __updateCase (studyCode, caseAssignment) {
	// function __updateCase (studyCode, persist, caseAssignment) {
	// return axios.put(utilityService.getApiUrl(`ui/case/update/v2?studyCode=` + studyCode + "&persist=" + persist),
	return axios.put(utilityService.getApiUrl(`ui/case?studyCode=` + studyCode),
		caseAssignment,
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __updateCaseBatch (studyCode, caseAssignmentArray, region) {
	// return axios.put(utilityService.getApiUrl(`ui/case/update/batch?studyCode=` + studyCode), // working but not for long as update not neccesary now
	console.log("__updateCaseBatch studyCode", studyCode)
	console.log("__updateCaseBatch region", region)
	// return axios.put(utilityService.getApiUrl(`ui/case/batch?studyCode=` + studyCode),
	return axios.put(utilityService.getApiUrl(`ui/case/batch?studyCode=` + studyCode + "&regionId=" + region),
		caseAssignmentArray,
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __confirmRegion (studyCode, region) {
	return axios.put(utilityService.getApiUrl(`ui/case/confirm?studyCode=` + studyCode + "&regionId=" + region),
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __confirmInterviewer (studyCode, region, staffId) {
	return axios.put(utilityService.getApiUrl(`ui/case/confirm?studyCode=` + studyCode + "&regionId=" + region + "&staffId=" + staffId),
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getComments (studyCode, refers) {
	return axios.get(utilityService.getApiUrl(`ui/comment/find?studyCode=` + studyCode + "&refers=" + refers),
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

export const caseAssignmentService = {
	getRegionList: (studyCode) => __getRegionList(studyCode),
	loadGeoJson: (studyCode, region) => __loadGeoJson(studyCode, region),
	loadGeoJsonDummy: (studyCode, region) => __loadGeoJsonDummy(studyCode, region),
	loadTablesJson: (studyCode, region) => __loadTablesJson(studyCode, region),
	// updateCase: (studyCode, persist, caseAssignment) => __updateCase(studyCode, persist, caseAssignment),
	updateCase: (studyCode, caseAssignment) => __updateCase(studyCode, caseAssignment),
	updateCaseBatch: (studyCode, caseAssignmentArray, region) => __updateCaseBatch(studyCode, caseAssignmentArray, region),
	confirmRegion: (studyCode, region) => __confirmRegion(studyCode, region),
	confirmInterviewer: (studyCode, region, staffId) => __confirmInterviewer(studyCode, region, staffId),
	updateAnaylsis: (EagleAssignmentUpdateArray) => __updateAnaylsis(EagleAssignmentUpdateArray),
	getComments: (studyCode, refers) => __getComments(studyCode, refers),
};
